module.exports = __webpack_public_path__ + "static/media/toiletTachiagari.99856452.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/toiletTachiagari.png
// module id = 1701
// module chunks = 1